<h1>Ledger</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let tab of tabs | visibleFinanceTabs" (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
    {{tab.title}}
  </a>
</nav>

<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="reloadAll()">Refresh All</button>
    <button mat-raised-button color="primary" (click)="createAccount()">Add Account</button>
    <button mat-raised-button color="primary" (click)="createTransaction()">Create Transaction</button>
    <button mat-raised-button color="primary" (click)="setOpeningBalances()">Set Opening Balances</button>
  </div>
</div>

<div class="chart-header">
  <h3>Chart of Accounts</h3>
  <div class="chart-controls">
    <mat-button-toggle-group [(ngModel)]="accountViewMode" aria-label="Chart of accounts view mode">
      <mat-button-toggle value="tree">Tree</mat-button-toggle>
      <mat-button-toggle value="list">List</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-button-toggle-group
      [(ngModel)]="accountStatusFilter"
      (ngModelChange)="onAccountStatusFilterChange()"
      aria-label="Chart of accounts status filter"
    >
      <mat-button-toggle value="all">All</mat-button-toggle>
      <mat-button-toggle value="active">Active</mat-button-toggle>
      <mat-button-toggle value="archived">Archived</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<div *ngIf="accountViewMode === 'tree'" class="tree-panel">
  <mat-tree [dataSource]="accountTreeDataSource" [treeControl]="accountTreeControl" class="account-tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <div class="tree-node-row">
        <button mat-icon-button disabled aria-hidden="true"></button>
        <button mat-button class="tree-node-button" (click)="selectAccountFromTree(node)">
          <span class="tree-main">
            <span [class.synthetic-label]="node.isSynthetic" [class.account-name-archived]="isArchivedAccount(node)">{{node.account.name}}</span>
          </span>
        </button>
        <span class="tree-balance-column" *ngIf="getNodeBalance(node) !== null; else noNodeBalance">
          ${{getNodeBalance(node) | number:'1.2-2'}}
        </span>
        <ng-template #noNodeBalance>
          <span class="tree-balance-column">-</span>
        </ng-template>
        <button
          mat-icon-button
          aria-label="Account actions"
          [matMenuTriggerFor]="accountNodeMenu"
          [matMenuTriggerData]="{ node: node }"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <div class="tree-node-row mat-tree-node">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.account.name">
          <mat-icon>{{accountTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
        </button>
        <button mat-button class="tree-node-button" (click)="selectAccountFromTree(node)">
          <span class="tree-main">
            <span [class.synthetic-label]="node.isSynthetic" [class.account-name-archived]="isArchivedAccount(node)">{{node.account.name}}</span>
          </span>
        </button>
        <span class="tree-balance-column" *ngIf="getNodeBalance(node) !== null; else noNodeBalanceNested">
          ${{getNodeBalance(node) | number:'1.2-2'}}
        </span>
        <ng-template #noNodeBalanceNested>
          <span class="tree-balance-column">-</span>
        </ng-template>
        <button
          mat-icon-button
          aria-label="Account actions"
          [matMenuTriggerFor]="accountNodeMenu"
          [matMenuTriggerData]="{ node: node }"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <div class="nested-tree" [class.hidden-tree]="!accountTreeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</div>

<table *ngIf="accountViewMode === 'list'" class="table" mat-table matSort [dataSource]="accountItems">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.id}}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.name}}</td>
  </ng-container>

  <ng-container matColumnDef="accountTypeCode">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.accountTypeCode}}</td>
  </ng-container>

  <ng-container matColumnDef="normalBalance">
    <th mat-header-cell *matHeaderCellDef>Normal Balance</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.normalBalance}}</td>
  </ng-container>

  <ng-container matColumnDef="balance">
    <th mat-header-cell *matHeaderCellDef>Balance</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <span *ngIf="getAccountBalance(item) !== null; else noBalance">${{getAccountBalance(item) | number:'1.2-2'}}</span>
      <ng-template #noBalance>-</ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
  </ng-container>

  <ng-container matColumnDef="actionmenu">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <button
        mat-icon-button
        aria-label="Account actions"
        [matMenuTriggerFor]="accountListMenu"
        [matMenuTriggerData]="{ account: item }"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="accountColumnNames"></tr>
  <tr class="listitem" [class.listitem-archived]="isArchivedAccount(rows)" mat-row *matRowDef="let rows; columns: accountColumnNames"></tr>
</table>

<mat-menu #accountNodeMenu="matMenu">
  <ng-template matMenuContent let-node="node">
    <button mat-menu-item (click)="addAccountAtNode(node)">
      <mat-icon>add</mat-icon>
      <span>Add Account Here</span>
    </button>
    <button mat-menu-item [disabled]="isSyntheticNode(node)" (click)="showAccountDetails(node)">
      <mat-icon>info</mat-icon>
      <span>View Details</span>
    </button>
    <button mat-menu-item [disabled]="isSyntheticNode(node)" (click)="editAccount(node)">
      <mat-icon>edit</mat-icon>
      <span>Edit Account</span>
    </button>
    <button mat-menu-item *ngIf="canArchiveAccount(node)" (click)="archiveAccount(node)">
      <mat-icon>archive</mat-icon>
      <span>Archive Account</span>
    </button>
    <button mat-menu-item *ngIf="canRestoreAccount(node)" (click)="restoreAccount(node)">
      <mat-icon>unarchive</mat-icon>
      <span>Restore Account</span>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #accountListMenu="matMenu">
  <ng-template matMenuContent let-account="account">
    <button mat-menu-item (click)="addAccountAtListItem(account)">
      <mat-icon>add</mat-icon>
      <span>Add Child Account</span>
    </button>
    <button mat-menu-item (click)="showAccountDetails(account)">
      <mat-icon>info</mat-icon>
      <span>View Details</span>
    </button>
    <button mat-menu-item (click)="editAccount(account)">
      <mat-icon>edit</mat-icon>
      <span>Edit Account</span>
    </button>
    <button mat-menu-item *ngIf="canArchiveAccount(account)" (click)="archiveAccount(account)">
      <mat-icon>archive</mat-icon>
      <span>Archive Account</span>
    </button>
    <button mat-menu-item *ngIf="canRestoreAccount(account)" (click)="restoreAccount(account)">
      <mat-icon>unarchive</mat-icon>
      <span>Restore Account</span>
    </button>
  </ng-template>
</mat-menu>

<h3>Transactions</h3>
<table class="table" mat-table [dataSource]="transactionItems">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.id}}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
  </ng-container>

  <ng-container matColumnDef="source">
    <th mat-header-cell *matHeaderCellDef>Source</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.source || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="postedAt">
    <th mat-header-cell *matHeaderCellDef>Posted At</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.postedAt | date:'medium'}}</td>
  </ng-container>

  <ng-container matColumnDef="externalReference">
    <th mat-header-cell *matHeaderCellDef>External Ref</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.externalReference || '-'}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="transactionColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: transactionColumnNames"></tr>
</table>

<div class="ledger-controls">
  <mat-form-field appearance="fill">
    <mat-label>Trial Balance As Of</mat-label>
    <input matInput type="date" [(ngModel)]="asOfDate">
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="loadTrialBalance()">Load Trial Balance</button>
</div>

<div class="ledger-controls">
  <mat-form-field appearance="fill">
    <mat-label>Account ID (optional)</mat-label>
    <input matInput [(ngModel)]="accountIdFilter">
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>From Date</mat-label>
    <input matInput type="date" [(ngModel)]="generalLedgerFromDate">
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>To Date</mat-label>
    <input matInput type="date" [(ngModel)]="generalLedgerToDate">
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="loadGeneralLedger()">Load General Ledger</button>
</div>

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
